import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ChannelInfoSliderState = {
  isActive: boolean;
  isMediaSliderActive: boolean;
  setSideBarToExpandOnClose: boolean;
  messageIdForInfo: string;
  showMessageInfo: boolean;
  showShareViaWhatsapp: boolean;
  showActionCentreSlier: boolean;
  showTicketSlider: boolean;
  scrollToAuditTrail: boolean;
};

const initialState: ChannelInfoSliderState = {
  isActive: false,
  isMediaSliderActive: false,
  setSideBarToExpandOnClose: false,
  messageIdForInfo: "",
  showMessageInfo: false,
  showShareViaWhatsapp: false,
  showActionCentreSlier: false,
  showTicketSlider: false,
  scrollToAuditTrail: false,
};

export const channelInfoSlider = createSlice({
  name: "channelInfoSlider",
  initialState,
  reducers: {
    setChannelInfoSliderActive: (
      state,
      action: PayloadAction<{
        isActive: boolean;
        setSideBarToExpandOnClose?: boolean;
      }>
    ) => {
      state.isActive = action.payload.isActive;
      state.setSideBarToExpandOnClose =
        action.payload.setSideBarToExpandOnClose ??
        state.setSideBarToExpandOnClose;
    },
    toggleChannelInfoSlider: (state) => {
      state.isActive = !state.isActive;
    },
    setMediaSliderActive: (state, action: PayloadAction<boolean>) => {
      state.isMediaSliderActive = action.payload;
    },
    openMessageInfoSlider: (state, action: PayloadAction<string>) => {
      state.messageIdForInfo = action.payload;
      state.showMessageInfo = true;
    },
    closeMessageInfoSlider: (state) => {
      state.messageIdForInfo = "";
      state.showMessageInfo = false;
    },
    openShareViaWhatsappSlider: (state) => {
      state.showShareViaWhatsapp = true;
    },
    closeShareViaWhatsappSlider: (state) => {
      state.showShareViaWhatsapp = false;
    },
    openActionCentreSlider: (state) => {
      state.showActionCentreSlier = true;
    },
    closeActionCentreSlider: (state) => {
      state.showActionCentreSlier = false;
    },
    openTicketSlider: (state) => {
      state.showTicketSlider = true;
    },
    closeTicketSlider: (state) => {
      state.showTicketSlider = false;
    },
    setScrollToAuditTrail: (state, action: PayloadAction<boolean>) => {
      state.scrollToAuditTrail = action.payload;
    },
  },
});

export const {
  setChannelInfoSliderActive,
  toggleChannelInfoSlider,
  setMediaSliderActive,
  openMessageInfoSlider,
  closeMessageInfoSlider,
  openShareViaWhatsappSlider,
  closeShareViaWhatsappSlider,
  openActionCentreSlider,
  closeActionCentreSlider,
  openTicketSlider,
  closeTicketSlider,
  setScrollToAuditTrail,
} = channelInfoSlider.actions;

export default channelInfoSlider.reducer;
